import React, {useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import Page from "../../../common/components/layout/layout-components/page";
import NavResponsive from "../../../common/components/nav-responsive";
import Layout from "../../../common/components/layout";
import SystemUsersView from "./system-users";
import DriverUsersView from "./driver-users";
import PageHeader from "../../../common/components/layout/layout-components/page/page-header";
import PageHeaderInfo from "../../../common/components/layout/layout-components/page/page-header-info";

export default function UsersView({translate, match, history, location}) {
    const dispatch = useDispatch()
    const ui = useSelector((state) => state.ui)
    const user = useSelector((state) => state.user)
    const resource = useSelector((state) => state.resource)

    const [tabs, setTabs] = useState(getTabs())
    const [breakpoint, setBreakpoint] = useState({})

    const handleTabChange = (resource) => {
        setTabs(
            tabs.map((it) => {
                it.current = it.resource === resource
                return it
            })
        )
    }

    const handleBreakpointChange = (breakpoint) => {
        setBreakpoint(breakpoint)
    }
    const currentTab = tabs.find(tab => tab.current)

    return (
        <Layout
            ui={ui}
            user={user}
            match={match}
            history={history}
            location={location}
            translate={translate}
            dispatch={dispatch}
            isAccessible={!(resource.errorStatus === 2)}
            onBreakpoinChange={handleBreakpointChange}
        >
            <Page>
                <PageHeader
                    title={translate('page.heading.System_Users')}
                    afterTitle={(
                        <PageHeaderInfo
                            dispatch={dispatch}
                        />
                    )}
                />

                <NavResponsive
                    tabs={tabs}
                    onTabChange={handleTabChange}
                    translate={translate}
                />

                {currentTab.name === 'SystemUsers' && (
                    <SystemUsersView
                        translate={translate}
                        history={history}
                    />
                )}

                {currentTab.name === 'DriverUsers' && (
                    <DriverUsersView
                        translate={translate}
                        history={history}
                    />
                )}

            </Page>
        </Layout>
    )
}

const getTabs = () => {
    return [
        {
            name: 'SystemUsers',
            resource: 'SystemUsers',
            current: true,
            visible: true
        },
        {
            name: 'DriverUsers',
            resource: 'DriverUsers',
            current: false,
            visible: true
        },
    ]
}
